// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { sparsePersonSchema } from '@/sparse/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

const externalUserSchema = z.object({
  id: z.string().uuid(),
  key: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  label: z.string(),
  email: z.string().email(),
  createdAt: dateTimeSchema,
  createdBy: sparsePersonSchema,
  lastUpdatedAt: dateTimeSchema,
  lastUpdatedBy: sparsePersonSchema,
  enabled: z.boolean(),
  notifications: z.array(
    z.object({
      id: z.string(),
      messageType: z.string(),
      channels: z.array(z.string()),
      activeChannels: z.array(z.string()),
    })
  ),
});

export type ExternalUser = z.infer<typeof externalUserSchema>;

export const externalUsersResponseSchema = z.object({
  data: z.array(externalUserSchema),
});

export const externalUserResponseSchema = z.object({
  data: externalUserSchema,
});

export type ExternalUserResponse = z.infer<typeof externalUserResponseSchema>;
